var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandDropDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_expand_more_24px",
    d: "M14.825,8.59,11,12.3,7.175,8.59,6,9.732l5,4.858,5-4.858Z",
    transform: "translate(-6 -8.59)",
    fill: "#203662"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandDropDown);
export default __webpack_public_path__ + "static/media/expandDropDown.6bb3742a9932ab425a159d83ad337975.svg";
export { ForwardRef as ReactComponent };